'use client';


import React from "react";

interface CarAccessoriesProps {
    accessories: (string | null)[];
}

const CarAccessories = ({ accessories }: CarAccessoriesProps) => {
    // Filtra gli accessori validi, rimuovendo i null
    const validAccessori = Array.isArray(accessories) ? accessories.filter((item): item is string => item !== null) : [];

    return (
        <div className="bg-white/40 p-4 rounded-lg shadow-md max-lg:shadow-none">
            <h2 className="text-lg font-bold mb-2 px-2 flex items-center">Accessori</h2>

            <div className="">
                <ul className="grid grid-cols-2 max-sm:grid-cols-1 gap-x-20 overflow-y-auto max-h-[500px]" id="lista-accessori">
                    {validAccessori.length > 0 ? (
                        validAccessori.map((item, idx) => (
                            <li
                                key={idx}
                                className={`text-sm flex justify-start my-1 text-gray-700 px-2 py-0.5 rounded-md`}
                            >
                                <strong>{item}</strong>
                            </li>
                        ))
                    ) : (
                        <p>Nessun accessorio disponibile</p>
                    )}
                </ul>
            </div>
        </div>
    );
};

export default CarAccessories;
